import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdStack = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M3 5.3C3 4.85817 3.35817 4.5 3.8 4.5H20.2C20.6418 4.5 21 4.85817 21 5.3C21 5.74183 20.6418 6.1 20.2 6.1H3.8C3.35817 6.1 3 5.74183 3 5.3Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 8.8C3 8.35817 3.35817 8 3.8 8H20.2C20.6418 8 21 8.35817 21 8.8C21 9.24183 20.6418 9.6 20.2 9.6H3.8C3.35817 9.6 3 9.24183 3 8.8Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 11.5C3.44772 11.5 3 11.9477 3 12.5V18.5C3 19.0523 3.44772 19.5 4 19.5H20C20.5523 19.5 21 19.0523 21 18.5V12.5C21 11.9477 20.5523 11.5 20 11.5H4Z" })
	]
});
export default SvgAdStack;
